import { ParsedCountry } from 'react-international-phone/dist/types'

export const hasNumberBeyondDialCode = (inputValue: string, dialCode: string): boolean => {
  const digitsOnly = inputValue.replace(/\D/g, '')
  const dialCodeDigits = dialCode.replace(/\D/g, '')
  return digitsOnly.length > dialCodeDigits.length
}

/**
 * Creates a phone field onChange handler that validates and stores phone number values
 * @param fieldName - The name of the field to update (e.g., 'cellNumber', 'telNumber')
 * @param setFieldValue - Formik's setFieldValue function
 * @param setDialCode - State setter for the dial code
 * @param hasNumberBeyondDialCode - Function to validate if input has digits beyond dial code
 * @returns onChange handler for PhoneField component
 */
export const createPhoneFieldChangeHandler = (
  fieldName: string,
  setFieldValue: (field: string, value: any) => void,
  setDialCode: (dialCode: string) => void,
  hasNumberBeyondDialCode: (inputValue: string, dialCode: string) => boolean,
) => {
  return (phone: string, meta: { country: ParsedCountry; inputValue: string }) => {
    // Only store the value if there's more than just the dial code
    const hasDigitsBeyondDialCode = hasNumberBeyondDialCode(meta.inputValue, meta.country.dialCode)
    setFieldValue(fieldName, hasDigitsBeyondDialCode ? meta.inputValue : '')
    setDialCode(meta.country.dialCode)
  }
}
